import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { useStableCallback } from '@soundxyz/graphql-react-query/utils';
import { MINIMIZED_PLAYER_HEIGHT } from '@components/AudioPlayerMobile/MinimizedPlayer';
import { MOBILE_NAV_HEIGHT } from '@components/main-components/mobile-nav/constants';
import { FeedPostModal } from '@components/modals/FeedPostModal';
import { useAuth } from '@context/auth/base';
import { useConnectedAuth } from '@context/auth/connected';
import { ModalType, useModal } from '@context/modal';
import { trackClickEvent } from '@lib/analytics';
import { useAudioController } from '@store/audio/AudioController';

export function FeedPostFloatingButton() {
  const { openModal } = useModal();
  const { authToken } = useAuth();
  const { login } = useConnectedAuth();
  const { activeTrackId } = useAudioController();

  const handleClick = useStableCallback(() => {
    if (!authToken) {
      login();
    } else {
      trackClickEvent({
        event: 'Create Post Clicked',
        properties: {
          sourceComponent: 'Feed Floating Button',
        },
      });
      openModal(ModalType.FEED_POST, {
        body: <FeedPostModal sourceLocation="Feed Floating Button" />,
      });
    }
  });

  const bottomCalc = useMemo(() => {
    if (activeTrackId) {
      return `calc(${MOBILE_NAV_HEIGHT}px + ${MINIMIZED_PLAYER_HEIGHT}px + env(safe-area-inset-bottom))`;
    } else {
      return `calc(${MOBILE_NAV_HEIGHT}px + env(safe-area-inset-bottom))`;
    }
  }, [activeTrackId]);
  return (
    <button
      className="fixed right-4 z-feedPostFloatingButton mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-fuchsia500/90 backdrop-blur-sm  transition-all active:scale-95 md:hidden"
      onClick={handleClick}
      style={{
        bottom: bottomCalc,
      }}
    >
      <FontAwesomeIcon icon={faPlus} size="2xl" className="text-white" />
    </button>
  );
}
